<template>
  <base-btn
    v-if="isAccountReactivation"
    class="btn-reactivate-account"
    type="secondary"
    size="small"
    @click="handleReactivateAccount"
  >
    {{ $t('message.navDrawer.userWarnings.reactivateAccount.actionBtn') }}
  </base-btn>
  <v-btn
    color="primary"
    depressed
    small
    v-else-if="planStatus === 'trialing'"
    @click="completePlan"
    >{{ $t('message.trialPeriodTime.activePlan') }}</v-btn
  >
  <div v-else-if="showActionButtonType !== 'none'">
    <base-btn
      v-if="planStatus !== 'trialing'"
      size="small"
      @click="handleResolvePending"
      style="white-space: nowrap"
    >
      {{ $t('message.trialPeriodTime.resolvePending') }}
    </base-btn>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ActionButton',
  components: {
    BaseBtn: () => import('@/components/BaseBtn.vue'),
  },
  props: {
    planStatus: {
      required: true,
    },
    isAccountReactivation: {
      required: false,
    },
  },
  data: () => ({
    loadings: {},
  }),
  methods: {
    ...mapMutations('user', [
      'UPDATE_ONLY_CUSTOMIZING',
    ]),
    handleResolvePending() {
      this.$root.$emit('openWarningPaymentIssue')
    },
    completePlan() {
      this.$root.$emit('ModalResetBillingCycle')
    },
    handleReactivateAccount() {
      this.UPDATE_ONLY_CUSTOMIZING(false)
      this.$router.push({ name: 'Cart' })
    },
  },
  computed: {
    ...mapState('dashboard', {
      showActionButtonType: (state) => state.warnings.showActionButtonType,
    }),
  },
}
</script>
<style>
.theme--dark .btn-reactivate-account {
  border: 1px solid var(--brand-60-base, #697af2);
  background: var(--neutral-100-white, #171924);
}
.theme--light .btn-reactivate-account {
  border: 1px solid var(--brand-60-base, #3f55ee);
  background: var(--neutral-100-white, #fff);
}
</style>
